interface ConfirmModalProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  tone: 'danger' | 'success';
  loading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmModal({
  open,
  title,
  message,
  confirmLabel,
  tone,
  loading,
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/40"
        onClick={loading ? undefined : onCancel}
      />
      <div className="relative bg-background-50 rounded-lg border border-background-200/70 w-full max-w-md p-6 shadow-xl">
        <div className="flex items-start gap-3 mb-4">
          <div
            className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${
              tone === 'danger'
                ? 'bg-red-100 text-red-600'
                : 'bg-secondary-100 text-secondary-700'
            }`}
          >
            <i
              className={`text-lg ${
                tone === 'danger' ? 'ri-pause-circle-line' : 'ri-play-circle-line'
              }`}
            ></i>
          </div>
          <div>
            <h3 className="text-base font-bold font-heading text-foreground-950">
              {title}
            </h3>
            <p className="text-sm text-foreground-500 mt-1">{message}</p>
          </div>
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            disabled={loading}
            className="px-4 py-2 rounded-md text-sm font-medium text-foreground-600 border border-background-300/60 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Annuler
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className={`px-4 py-2 rounded-md text-sm font-semibold text-white transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed ${
              tone === 'danger'
                ? 'bg-red-600 hover:bg-red-700'
                : 'bg-secondary-500 hover:bg-secondary-600'
            }`}
          >
            {loading && <i className="ri-loader-4-line animate-spin"></i>}
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}